import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { Plus } from "@phosphor-icons/react";
import { useFormik } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import { iconSize } from "../../const/sizes";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";
import useScreenWidth from "../../lib/useGetScreenWidth";
import RequiredForm from "../RequiredForm";
import Textarea from "../Textarea";

export default function TambahCourseTemaModal() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const sw = useScreenWidth();

  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();

  const formik = useFormik({
    validateOnChange: false,

    initialValues: {
      name: "",
      description: "",
    },

    validationSchema: yup.object().shape({
      name: yup.string().required("Nama Tema harus diisi"),
      description: yup.string().required("Deskripsi Tema harus diisi"),
    }),

    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      const url = `api/course/theme/savetheme`;
      const payload = new FormData();
      payload.append("theme_name", values.name);
      payload.append("description", values.description);

      cr.post(url, payload)
        .then((r) => {
          if (r.status === 201) {
            toast({
              title: r.data.message,
              status: "success",
              duration: 5000,
              isClosable: true,
            });
            setTrigger(!trigger);
            resetForm();
          }
        })
        .catch((e) => {
          console.log(e);
          toast({
            title: e.response.data.message,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <>
      {sw >= 500 ? (
        <Button
          colorScheme="p"
          className="clicky"
          leftIcon={<Icon as={Plus} fontSize={iconSize} weight="bold" />}
          pl={3}
          onClick={onOpen}
        >
          Tambah
        </Button>
      ) : (
        <IconButton
          colorScheme="p"
          className="clicky"
          aria-label="tambahKategoriBlog"
          icon={<Icon as={Plus} fontSize={iconSize} />}
          onClick={onOpen}
        />
      )}

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Tambah Tema Course</ModalHeader>

          <ModalBody>
            <form id="tambahkategoriBlogForm" onSubmit={formik.handleSubmit}>
              <FormControl mb={4} isInvalid={formik.errors.name ? true : false}>
                <FormLabel>
                  Nama Tema
                  <RequiredForm />
                </FormLabel>
                <Input
                  name="name"
                  placeholder="Masukkan nama tema"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                />
                <FormErrorMessage>{formik.errors.name}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={formik.errors.description ? true : false}>
                <FormLabel>
                  Deskripsi Tema
                  <RequiredForm />
                </FormLabel>
                <Textarea
                  name="description"
                  formik={formik}
                  placeholder="Masukkan deskripsi tema"
                />
                <FormErrorMessage>{formik.errors.description}</FormErrorMessage>
              </FormControl>
            </form>
          </ModalBody>

          <ModalFooter gap={2}>
            <Button onClick={onClose} className="btn clicky">
              Batal
            </Button>

            <Button
              type="submit"
              form={"tambahkategoriBlogForm"}
              colorScheme="p"
              className="clicky"
              isLoading={loading}
            >
              Tambahkan
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
